import datacentral from '@/utils/axios/datacentral'
import queryString from 'query-string'
import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'
import { ResponseArray, ResponseObject } from '@/types/shared'
import type {
    DataAccessAssignment,
    CreateDataAccessAssignmentPayload,
    UpdateDataAccessAssignmentPayload,
    ResourceGroup,
    Column,
    DataAccessListFilters,
    DataAccessPreviewResponse,
} from '../types'

export const getDataAccessAssignments = async (
    payload: DataGridPayload | DataAccessListFilters
): Promise<ResponseArray<DataAccessAssignment>> => {
    const response = await datacentral.get<ResponseArray<DataAccessAssignment>>(
        `data-access-assignments?${queryString.stringify(payload)}`
    )
    return response?.data
}

export const getDataAccessAssignmentById = async (
    id: string
): Promise<ResponseObject<DataAccessAssignment>> => {
    const response = await datacentral.get<
        ResponseObject<DataAccessAssignment>
    >(`data-access-assignments/${id}`)
    return response?.data
}

export const createDataAccessAssignment = async (
    data: CreateDataAccessAssignmentPayload
): Promise<ResponseObject<DataAccessAssignment>> => {
    const response = await datacentral.post(`data-access-assignments`, data)
    return response?.data
}

export const updateDataAccessAssignment = async (
    id: string,
    data: UpdateDataAccessAssignmentPayload
): Promise<ResponseObject<DataAccessAssignment>> => {
    const response = await datacentral.put(
        `data-access-assignments/${id}`,
        data
    )
    return response?.data
}

export const deleteDataAccessAssignment = async (
    id: string
): Promise<ResponseObject<DataAccessAssignment>> => {
    const response = await datacentral.delete(`data-access-assignments/${id}`)
    return response?.data
}

export const toggleDataAccessAssignment = async (
    id: string,
    is_active: boolean
): Promise<ResponseObject<DataAccessAssignment>> => {
    const response = await datacentral.patch(
        `data-access-assignments/${id}/toggle`,
        { is_active }
    )
    return response?.data
}

export const getResourceCatalog = async (): Promise<
    ResponseArray<ResourceGroup>
> => {
    const response = await datacentral.get<ResponseArray<ResourceGroup>>(
        'data-access-assignments/resource-catalog'
    )
    return response?.data
}

export const getColumnsForResource = async (
    resourceKey: string
): Promise<ResponseArray<Column>> => {
    const response = await datacentral.get<ResponseArray<Column>>(
        `data-access-assignments/columns/${resourceKey}`
    )
    return response?.data
}

export const previewDataAccessAssignment = async (
    id: number,
    employeeId: number
): Promise<ResponseObject<DataAccessPreviewResponse>> => {
    const response = await datacentral.get<
        ResponseObject<DataAccessPreviewResponse>
    >(`data-access-assignments/${id}/preview`, {
        params: { as_employee_id: employeeId },
    })
    return response?.data
}

export const getKeycloakResources = async (): Promise<
    ResponseArray<{
        id: string
        name: string
        displayName?: string
        uris?: string[]
    }>
> => {
    const response = await datacentral.get<
        ResponseArray<{
            id: string
            name: string
            displayName?: string
            uris?: string[]
        }>
    >('data-access-assignments/keycloak-resources')
    return response?.data
}
